var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "coBrokerModal",
    attrs: {
      id: "co-broker-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "lg",
    },
    on: { show: _vm.handleShow, hide: _vm.handleClearData },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("direct-to-lender.participants.coBrokerApplication")
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "mb-3" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.modalDescriptionToShow) + "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "my-4", attrs: { "align-v": "start" } },
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex flex-column align-items-center step-circle-container",
                    attrs: { cols: "1" },
                  },
                  [_c("div", { staticClass: "step" }, [_vm._v("1")])]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "9" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "auto" } }, [
                          _c("h6", { staticClass: "mb-0 bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "direct-to-lender.participants.selectMortgage"
                                  )
                                ) +
                                ":\n            "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-row",
                      { staticClass: "mt-3" },
                      _vm._l(
                        _vm.requestedMortgageDetailsWithType,
                        function (mortgage) {
                          return _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.top",
                                  value: {
                                    title: _vm.$t(
                                      "direct-to-lender.participants.mortgageCannotBeCobrokered",
                                      {
                                        cobrokeredTo:
                                          _vm.IS_MORTGAGE_CO_BROKERED(
                                            mortgage.type
                                          ),
                                      }
                                    ),
                                    disabled: !_vm.IS_MORTGAGE_CO_BROKERED(
                                      mortgage.type
                                    ),
                                  },
                                  expression:
                                    "{\n              title: $t(\n                'direct-to-lender.participants.mortgageCannotBeCobrokered',\n                {\n                  cobrokeredTo: IS_MORTGAGE_CO_BROKERED(mortgage.type)\n                }\n              ),\n              disabled: !IS_MORTGAGE_CO_BROKERED(mortgage.type)\n            }",
                                  modifiers: { top: true },
                                },
                              ],
                              key: mortgage.type,
                              attrs: { cols: "4" },
                            },
                            [
                              _c(
                                "card-radio-field",
                                {
                                  class: {
                                    disabled: _vm.IS_MORTGAGE_CO_BROKERED(
                                      mortgage.type
                                    ),
                                  },
                                  attrs: {
                                    id: "mortgage-" + mortgage.type,
                                    name: "mortgage-" + mortgage.type,
                                    type: "checkbox",
                                    checked: _vm.isMortgageSelected(
                                      mortgage.type
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleSelectMortgage(
                                        mortgage.type
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("h6", { staticClass: "mb-0 bold" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "application-form.mortgage-type"
                                          )
                                        ) +
                                        ":\n\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-capitalize ml-1 fw-normal",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-form." +
                                                  mortgage.type
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h6", { staticClass: "mb-0 bold" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("global.doorr.mortgageAmount")
                                        ) +
                                        ":\n\n                "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "ml-1 fw-normal" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("formatMoneyValueLong")(
                                                mortgage.amount
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(_vm.currentStepComponent, {
              ref: "stepRef",
              tag: "component",
              attrs: {
                "current-data": _vm.data,
                "show-agents-table": _vm.showAgentsTable,
                "agent-search-valid": _vm.agentFullNameIsValid,
                validations: {
                  firstNameIsValid: _vm.firstNameIsValid,
                  lastNameIsValid: _vm.lastNameIsValid,
                  agentFullNameIsValid: _vm.agentFullNameIsValid,
                },
              },
              on: {
                "change-data": _vm.handleChangeData,
                "clear-data": _vm.handleClearData,
                "search-agent": _vm.handleSearchAgent,
                "show-favorites": _vm.handleShowFavorites,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.showPreviousStep
              ? _c("simple-button", {
                  attrs: {
                    "class-name": "btn-sm mr-2",
                    type: "white",
                    text: _vm.$t("request-package.steps.previousStep"),
                  },
                  on: { click: _vm.handlePreviousStep },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isConfirmationStep
              ? _c("simple-button", {
                  attrs: {
                    "class-name": "btn-sm",
                    disabled: !_vm.isValid,
                    text: _vm.$t("request-package.steps.nextStep"),
                  },
                  on: { click: _vm.handleNextStep },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isConfirmationStep
              ? _c(
                  "inline-prompt",
                  {
                    staticClass: "d-inline-block",
                    attrs: {
                      "accept-button-type": "primary",
                      disabled:
                        !_vm.data.consentChecked ||
                        !_vm.mortgagesSelected.length,
                      "confirmation-text": _vm.$t(
                        "direct-to-lender.participants.coBrokerAction"
                      ),
                      "confirmation-text-color": "text-dark",
                    },
                    on: { accept: _vm.handleSubmit },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "preConfirmationContent",
                          fn: function () {
                            return [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.participants.submitButtonTooltip"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1200182654
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("simple-button", {
                      attrs: {
                        loading: _vm.submitButtonLoader,
                        "class-name": "btn-sm",
                        disabled:
                          !_vm.submitButtonValidation ||
                          !_vm.mortgagesSelected.length,
                        text: _vm.$t("request-package.steps.submit"),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }